/* tslint:disable:variable-name */

import { ClientApp } from '@/models/client/models'
import { TRANSIENT_BASE_OBJECT_DEFAULT } from '@/models/core/base'

export const CLIENT_APP_DEFAULT: ClientApp = {
  ...TRANSIENT_BASE_OBJECT_DEFAULT,
  organisation: '',
  handle: '',
  name: '',
  view_id: '',
  description: '',
}
